import React from "react";
import { FilterIcon } from "../../icons/FilterIcon";
import { RemoveIcon } from "../../icons/RemoveIcon";
import { Flex } from "../../components/Flex";
import { Badge } from "../../components/Circle";
import { ActionButton, DropdownButton } from "../../components/Button";

const FilterButton = ({ options=[], applyFilter, deleteQueryFilter, selected }) => {
    return(
        <DropdownButton
            items={options.map(option => ({
                key: option.id,
                title: <Flex align="center" justify="space-between" gap={{ right: 12 }} style={{ minWidth: "80px"}}>
                            <span>{option.name}</span>
                            <RemoveIcon
                                size={16}
                                color="var(--sp-label-color)"
                                hoverColor="var(--sp-error-color)"
                                onClick={(e) => {e.stopPropagation(); deleteQueryFilter(option.id)}}
                            />
                        </Flex>
            }))}
            onMenuClick={({ key }) => applyFilter(key)}
        >
            <span style={{ position: "relative"}}>
            <ActionButton title="Saved filters">
                <FilterIcon />
            </ActionButton>
            {selected ? <sup style={{ position: "absolute", top: 0, right: 0, transform: "translate(30%, -30%)" }}><Badge size={8} color="var(--sp-main-color)" /></sup>: null}
            </span>
        </DropdownButton>
    )
};

export { FilterButton };